// @flow

export default {
  apiKey: 'AIzaSyCZlSOuOA0Tl0dFe1ZLOf-KSLAr6jDzzaA',
  authDomain: 'mvhs-choir-attendance.firebaseapp.com',
  databaseURL: 'https://mvhs-choir-attendance.firebaseio.com',
  projectId: 'mvhs-choir-attendance',
  storageBucket: 'mvhs-choir-attendance.appspot.com',
  messagingSenderId: '474053041538'
};



// WEBPACK FOOTER //
// ./utils/firebaseConfig.js